import { mapState } from 'vuex';

export default {
  data() {
    return {
      // 
    }
  },
  computed: {
    ...mapState('vocabulary', ['categoryLists', 'categorizedWords', 'menuItemPerPage', 'modalCategoryId'])
  },
  methods: {
    /**
     * Update category count label on add/delete/move of category word/s
     *
     * @param {Number} count selected words count to be processed
     * @param {Number|Null} categoryId category where items will be added/moved
     * @param {String} action action to be done on the category word/s
     * @return void
     */
    updateCategoryCount(count, action, categoryId = null) {
      if (this.$_.isNull(this.categoryLists)) {
        return;
      }

      const index = this.categoryLists.findIndex(category => category.id === categoryId);
      if (['add', 'move'].includes(action)) {
        const categoryCountPlus = this.categoryLists[index];
        categoryCountPlus.total_items = categoryCountPlus.total_items + count;
        categoryCountPlus.left_items = categoryCountPlus.left_items - count;
      }

      const modalIndex = this.categoryLists.findIndex(category => category.id === this.modalCategoryId);
      if (['delete', 'move'].includes(action)) {
        const categoryCountMinus = this.categoryLists[modalIndex];
        categoryCountMinus.total_items = categoryCountMinus.total_items - count;
        categoryCountMinus.left_items = categoryCountMinus.left_items + count;
      }
    },

    addWordsOnCategoryList(params) {
      if (!this.categorizedWords) return false;
      
      this.categorizedWords.hits = [params].concat(this.categorizedWords.hits);
      this.categorizedWords.nbHits += 1;

      // Update list length and remove excess array item based on itemPerPage
      this.categorizedWords.hits.length = this.menuItemPerPage < this.categorizedWords.nbHits
        ? this.menuItemPerPage
        : this.categorizedWords.hits.length;
    }
  }
}
